var ChangeLog = React.createClass({
    mixins: [React.addons.PureRenderMixin],
    //nada
    render: function() {
        var indented = { margin: '10px 20px' }
        return (
            <div>
				<h1>Change Log</h1>
				<div style={indented}>Most recent changes and developments on the site.</div>
				<hr />
				<div style={indented}>
				<strong>
				IF THINGS ARE BROKEN, PLEASE CONTACT ADMIN WITH SCREENSHOT/INFORMATION FOR QUICK FIXES.
				</strong>
				</div>
				<DayLog
					data={{
						date: 'LEGEND',
						log: [
							// '/d/default',
							'/n/New Feature',
							'/f/Fixed Bug',
							'/s/Suggested Feature',
							'/i/Pop Shop',
							'/a/Admin',
						],
					}}
				/>
				{/*
					Start of logs
				*/}
				
				<DayLog
                    data={{
                        date: '2022-5-10',
                        log: ['/n/Added Custom MOBC Pool Stick and more in Pop Shop - Thanks Matty J!',
                              '/n/Added Team V, Foxy and Matty sticks in settings.',
                              '/s/Redesigned the Pop Shop.'],
                    }}
                />

                <DayLog
					data={{
						date: '2022-4-28',
						log: ['/n/Allowing lame guests to join rooms', 
						'/s/Lame guests cannot see and/or type in chat', 
						'/s/Rooms can disallow guests from joining', 
						'/n/Brought back change log'],
					}}
				/>

				<DayLog
					data={{
						date: '2022-4-26',
						log: ['/i/Added colored balloons to Pop Shop'],
					}}
				/>

				<SeeAlso />
			</div>
        )
    },
})

var DayLog = React.createClass({
    mixins: [React.addons.PureRenderMixin],

    render: function() {
        /*
        	Tags:
        		/d/efault
        		/a/dded
        		/e/dited
        		/r/emoved
        		/i/mproved-fixed
        		/m/oderater

        	Order:
        		m, a, i, e, r

        	Example:
        		'/m/You're a mod, Harry!'
        		'/a/Added self-destruct'
        		'/i/Fixed brain'
        	*/
        return (
            <div>
				{this.props.data.date ? <h3>{this.props.data.date}</h3> : null}
				<ul>
					{this.sort(this.props.data.log).map((log, i) => {
						if (this.getTag(log) === 'm' && !window.user.mod) return null
						else {
							var color = this.getColor(log)
							return (
								<li style={{ color: color }} key={i}>
									<span style={{ color: 'white' }}>{this.casing(this.removeTag(log))}</span>
								</li>
							)
						}
					})}
				</ul>
			</div>
        )
    },
    hasTag: function(s) {
        return s.charAt(0) == '/' && s.charAt(2) == '/'
    },
    getTag: function(s) {
        return this.hasTag(s) ? s.charAt(1) : 'd'
    },
    removeTag: function(s) {
        return this.hasTag(s) ? s.slice(3, s.length) : s
    },
    getColor: function(s) {
        var c = { a: 'white', n: 'lime', s: 'goldenrod', f: 'red', i: 'lightblue', m: 'violet' }
        return c[this.getTag(s)]
    },
    casing: function(s) {
        return s.charAt(0).toUpperCase() + s.slice(1)
    },
    sort: function(arr) {
        var o = {
            m: 0,
            a: 1,
            i: 2,
            e: 3,
            r: 4,
        }
        return arr.sort((a, b) => {
            var c = this.getTag(a),
                d = this.getTag(b)
            return o[c] === o[d] ? 0 : o[c] < o[d] ? -1 : 1
        })
    },
})